import React from 'react';
import { Phone, Mail, Instagram, Facebook } from 'lucide-react';
import { contactInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_6ff89c30-29b2-4ef0-998b-b868478450b8/artifacts/blcaejru_WhatsApp%20Image%202026-02-08%20at%2018.37.39.jpeg" 
                alt="MS Building Contractors" 
                className="h-16 w-auto mb-4 bg-white p-2 rounded"
              />
            </div>
            <h3 className="text-xl font-bold mb-3">{contactInfo.companyName}</h3>
            <p className="text-gray-400 mb-4 max-w-md">
              All aspects of building work undertaken - no job too big or too small. 
              From maintenance to full extension packages, we deliver quality craftsmanship on every project.
            </p>
            <div className="mt-4">
              <div className="text-green-500 font-semibold mb-2">Service Areas:</div>
              <div className="text-gray-400 text-sm">
                Goole • Howden • Thorne • Selby • York • Surrounding Areas
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <button onClick={() => scrollToSection('home')} className="text-gray-400 hover:text-green-500 transition-colors">
                  Home
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-gray-400 hover:text-green-500 transition-colors">
                  Services
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('gallery')} className="text-gray-400 hover:text-green-500 transition-colors">
                  Gallery
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('about')} className="text-gray-400 hover:text-green-500 transition-colors">
                  About
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-gray-400 hover:text-green-500 transition-colors">
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Us</h4>
            <ul className="space-y-3">
              {contactInfo.directors.map((director, index) => (
                <li key={index}>
                  <a 
                    href={`tel:${director.phone}`} 
                    className="flex items-center space-x-2 text-gray-400 hover:text-green-500 transition-colors"
                  >
                    <Phone className="w-4 h-4" />
                    <span>{director.name}: {director.phone}</span>
                  </a>
                </li>
              ))}
              <li>
                <a 
                  href={`mailto:${contactInfo.email}`} 
                  className="flex items-center space-x-2 text-gray-400 hover:text-green-500 transition-colors break-all"
                >
                  <Mail className="w-4 h-4 flex-shrink-0" />
                  <span>{contactInfo.email}</span>
                </a>
              </li>
            </ul>

            {/* Social Media Links */}
            <div className="mt-6">
              <h4 className="text-lg font-semibold mb-4">Follow Us</h4>
              <div className="flex space-x-4">
                {contactInfo.socialMedia?.instagram && (
                  <a
                    href={contactInfo.socialMedia.instagram}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 bg-gray-800 hover:bg-green-600 rounded-full flex items-center justify-center transition-colors"
                    aria-label="Instagram"
                  >
                    <Instagram className="w-5 h-5" />
                  </a>
                )}
                {contactInfo.socialMedia?.facebook && (
                  <a
                    href={contactInfo.socialMedia.facebook}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 bg-gray-800 hover:bg-green-600 rounded-full flex items-center justify-center transition-colors"
                    aria-label="Facebook"
                  >
                    <Facebook className="w-5 h-5" />
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; {currentYear} {contactInfo.companyName}. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
